module.exports = __webpack_public_path__ + "img/plus-new.2d781b5d.svg";